import { IOrderServiceMock } from './order.mock.types';

export const mockOrderService = (): IOrderServiceMock => ({
  fetchOrders: jest.fn(),
  fetchOrder: jest.fn(),
  createOrder: jest.fn(),
  updateOrder: jest.fn(),
  deleteOrder: jest.fn(),

  exportOrderPriceDistribution: jest.fn()
});
